import capitalize from 'lodash/capitalize'
import { type PageRouteData } from '@/features/shared/utils/setPageProps'

export const transformRoutesToTitle = (pathname: string, routeData: PageRouteData) => {
  const partnerName = 'Shipt'
  try {
    const baseTitle = routeData ? pathname.split('/')[1] : '404'
    const title = routeData?.pageTitle || capitalize(baseTitle)

    return `${title} - ${partnerName}`
  } catch (e) {
    return partnerName
  }
}
